module.exports = __webpack_public_path__ + "static/media/operations_use_case_1.62598eeb.svg";